import styled, { css } from 'styled-components';

export const ChartContainer = styled.div<{ $mainGoalOnly: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;

  ${({ $mainGoalOnly }) =>
    $mainGoalOnly &&
    css`
      display: block;
    `};

  ${({ theme }) => theme.breakpoints.up('sm')} {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 800px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const ChartItem = styled.div`
  border-right: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  min-width: 0;

  &:nth-child(2n) {
    border-right: none;
  }

  &:nth-child(-2n) {
    border-bottom: none;
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    &:nth-child(2n) {
      border-right: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    }

    &:nth-child(-2n) {
      border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    }

    &:nth-child(3n) {
      border-right: none;
    }

    &:nth-child(-3n) {
      border-bottom: none;
    }
  }

  @media (min-width: 800px) {
    &:nth-child(2n) {
      border-right: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    }

    &:nth-child(-2n) {
      border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    }

    &:nth-child(3n) {
      border-right: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    }

    &:nth-child(-3n) {
      border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
    }

    &:nth-child(4n) {
      border-right: none;
    }

    &:nth-child(-4n) {
      border-bottom: none;
    }
`;
